import { render, staticRenderFns } from "./videoXgPlayer.vue?vue&type=template&id=6cc1d523&scoped=true"
import script from "./videoXgPlayer.vue?vue&type=script&lang=js"
export * from "./videoXgPlayer.vue?vue&type=script&lang=js"
import style1 from "./videoXgPlayer.vue?vue&type=style&index=1&id=6cc1d523&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1d523",
  null
  
)

export default component.exports